import styled from 'styled-components';

// Container principale
export const Container = styled.div`
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

// Sezione generica
export const Section = styled.div`
    margin-bottom: 20px;
`;

// Header espandibile per Action Button
export const ActionButtonHeader = styled.div<{ isOpen: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    background-color: ${(props) => (props.isOpen ? '#f0f0f0' : 'white')};
    transition: background-color 0.2s;

    &:hover {
        background-color: #f8f8f8;
    }
`;

// Icona freccia per l'header espandibile
export const ExpandIcon = styled.span<{ isOpen: boolean }>`
    transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: transform 0.2s;
`;

// Pannello customizzazioni
export const CustomizationPanel = styled.div`
    margin-top: 10px;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #fafafa;
`;

// Container per ogni campo di customizzazione
export const CustomizationField = styled.div`
    margin-bottom: 15px;
`;

// Label per i campi
export const FieldLabel = styled.label`
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
`;

// Container per icon image
export const IconImageContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

// Area preview dell'icona
export const IconPreview = styled.div`
    width: 40px;
    height: 40px;
    border: 2px dashed #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
`;

// Immagine dell'icona
export const IconImage = styled.img`
    max-width: 100%;
    max-height: 100%;
`;

// Placeholder per l'icona
export const IconPlaceholder = styled.span`
    font-size: 12px;
    color: #999;
`;

// Container per i bottoni di azione
export const ActionButtonsContainer = styled.div`
    display: flex;
    gap: 5px;
`;

// Bottone di azione generico
export const ActionButton = styled.button`
    padding: 5px 10px;
    font-size: 12px;
    border: 1px solid #ddd;
    border-radius: 3px;
    background-color: white;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #f0f0f0;
    }

    &:active {
        background-color: #e0e0e0;
    }
`;

// Container per text label con reset
export const TextLabelContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

// Input per text label
export const TextInput = styled.input`
    flex: 1;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
`;

// Color picker
export const ColorPicker = styled.input`
    width: 50px;
    height: 30px;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
`;

// Select per dimensioni
export const SizeSelect = styled.select`
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: white;
`;

// Container per preview del bottone
export const PreviewContainer = styled.div`
    margin-top: 20px;
`;

// Preview del bottone
export const ButtonPreview = styled.div<{
    backgroundColor: string;
    textColor: string;
    borderSize: string;
    borderColor: string;
    borderRadius: string;
}>`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background-color: ${(props) => props.backgroundColor};
    color: ${(props) => props.textColor};
    border: ${(props) => props.borderSize} solid ${(props) => props.borderColor};
    border-radius: ${(props) => props.borderRadius};
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
        opacity: 0.8;
    }
`;

// Icona nel preview del bottone
export const PreviewIcon = styled.img`
    width: 16px;
    height: 16px;
`;

// Info box per prodotto
export const ProductInfoBox = styled.div`
    margin-bottom: 15px;
    padding: 10px;
    background: #f5f5f5;
    border-radius: 4px;
`;

// Note informative
export const InfoNote = styled.div`
    margin-top: 10px;
    font-size: 12px;
    color: #666;
    font-style: italic;
`;

// Debug container
export const DebugContainer = styled.details`
    margin-top: 20px;
    font-size: 12px;
    color: #666;
`;

// Debug content
export const DebugContent = styled.pre`
    background: #f9f9f9;
    padding: 10px;
    margin-top: 10px;
    overflow-x: auto;
`;

// Customer data box
export const CustomerDataBox = styled.div`
    padding: 10px;
    background: #e8f5e8;
    border-radius: 4px;
`;

// Styled button per layout colonna con indentazione (simile ad AR Editor)
export const StyledButton = styled.button`
    margin-left: 24px;
    margin-top: 8px;
    padding: 8px 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: white;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 14px;

    &:hover {
        background-color: #f0f0f0;
        border-color: #007bff;
    }

    &:active {
        background-color: #e0e0e0;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        background-color: #f5f5f5;
    }
`;

// Container per layout a colonna dei pulsanti VTO Reference
export const VTOButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0;
    margin-top: 10px;
`;
